import eduWebConfig from "./eduwebconfig"
/**
 * 删除非顶部子菜单
 * @param children
 */
function deleteSchChildren(children) {
    if (children) {
        for (let i = children.length - 1; i >= 0; i--) {
            if (children[i].is_school == 1) {
                delete children[i]
            } else {
                deleteSchChildren(children[i].Children)
            }
        }
    }
}

/**
 * 去掉子菜单中数组为空的部分
 * @param children
 * @returns {*}
 */
function filterSchChildren(children) {
    if (children) {
        let result = children.filter(function (val) {
            return val
        })
        for (let i = 0; i < result.length; i++) {
            if (result[i].Children) {
                result[i].Children = filterSchChildren(result[i].Children)
            }
        }
        return result
    }
    return null
}

const permission = {
    state: {
        menus: null, //菜单及操作权限
        schools: null, //学校权限
        currentSchool: null, //当前学校
        currentRoleGroup: null,
        currentOrganizationId: null,
        currentOrganizationName: null,
        isEnterOrg:false
    },
    mutations: {
        SET_PERMISSIONS: (state, permissions) => {
            
            // 心理老师屏蔽心理测评功能
            if (eduWebConfig.state.eduWebConfigInfo && eduWebConfig.state.eduWebConfigInfo.menus.length && permissions.currentRoleGroup == 3) {
                state.menus = eduWebConfig.state.eduWebConfigInfo.menus
            }
            // 学生屏蔽心理 字段
            else if (eduWebConfig.state.eduWebConfigInfo && eduWebConfig.state.eduWebConfigInfo.studentMenus.length && permissions.currentRoleGroup == 8) {
                state.menus = eduWebConfig.state.eduWebConfigInfo.studentMenus
            } else {
                // 课前讲座调查问卷
                if (eduWebConfig.state.eduWebConfigInfo.staticMenus) {
                    state.menus = permissions.menus.concat(eduWebConfig.state.eduWebConfigInfo.staticMenus)
                } else {
                    state.menus = permissions.menus
                }

            }

            state.schools = permissions.schools
            state.currentSchool = permissions.currentSchool
            state.currentRoleGroup = permissions.currentRoleGroup
            state.currentOrganizationId = permissions.currentOrganizationId
            state.currentOrganizationName = permissions.currentOrganizationName
        },
        //更新组织机构信息
        updateOrgInfo: (state, permissions) => {
            state.currentRoleGroup = permissions.roleGroup
            state.currentOrganizationId = permissions.organizationId
            state.currentOrganizationName = permissions.organizationName
            
        },
        // 设置进入组织机构标识
        setEnterOrg(state,isEnterOrg){
            state.isEnterOrg = isEnterOrg
        },
        SET_CURRENTSCHOOL: (state, school) => {
            state.currentSchool = school
        },
        SET_ORGANIZATION: (state, info) => {
            state.currentRoleGroup = info.currentRoleGroup
            state.currentOrganizationId = info.currentOrganizationId
            state.currentOrganizationName = info.currentOrganizationName
        }
    },
    actions: {
        /**
         * 生成权限数据
         * @param commit
         * @param data
         * @constructor
         */
        GeneratePermisions({
            commit
        }, data) {
            //过滤学校权限菜单
            if (data.currentRoleGroup != 3) {
                if (data.menus != null && data.menus.length > 0) {
                    for (let i = data.menus.length - 1; i >= 0; i--) {
                        if (data.menus[i].is_school == 1) {
                            delete data.menus[i]
                        } else {
                            deleteSchChildren(data.menus[i].Children)
                        }
                    }
                    //去掉数组为空的部分
                    data.menus = filterSchChildren(data.menus)
                }
            }
            commit('SET_PERMISSIONS', data)
        }
    }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js